// 컴포넌트 라우팅 정의
import Vue from 'vue'
import Router from 'vue-router'

import Login from '../components/login/Login.vue'
import RequestPermission from '../components/login/RequestPermission.vue'

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/requestPermission',
        name: 'requestPermission',
        component: RequestPermission
    },
    // default route
    {
        path: '*',
        redirect: '/login'
    }
]

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes
})
